// update along with app/lib/enums/export_status.py
const ExportStatus = { PROCESSING: 'Processing', DONE: 'Done' };

export { ExportStatus };
